/// Peças dos filtros de escolha múltipla que não são componente (o `MultiFilter` mora em
/// `data-view.tsx`).

/// A lista volta na ordem das opções, para a URL não mudar só porque a pessoa marcou noutra ordem.
export function inOptionOrder<T extends string>(
  chosen: readonly string[],
  options: ReadonlyArray<{ value: T }>,
): T[] {
  return options.map((option) => option.value).filter((value) => chosen.includes(value));
}

/// Uma etiqueta por escolha marcada; tocar nela desmarca só aquela.
export function choiceChips<T extends string>(
  key: string,
  value: readonly T[],
  options: ReadonlyArray<{ value: T; label: string }>,
  onChange: (value: T[]) => void,
): Array<{ key: string; label: string; onRemove: () => void }> {
  return options
    .filter((option) => value.includes(option.value))
    .map((option) => ({
      key: `${key}:${option.value}`,
      label: option.label,
      onRemove: () => onChange(value.filter((one) => one !== option.value)),
    }));
}
